var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sAlert',{staticClass:"bidding-type-info"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('template',{slot:"desc"},[_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.description),expression:"description"}],staticClass:"bidding-type-info__description"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }